import { MarketingClientConstants } from "../constants/marketing-client-constants";
import { Utils } from "../utils/utils";
import { DOMHelper } from "./dom-helper";

export class ShareArticleErrorHandler {
    element: HTMLElement | null;
    shareArticleErrorMessageElement: HTMLElement | null;
    email: HTMLInputElement | null;
    defaultMessage: string;
    errorMessageContainerClass = ".share-article-error-message";
    dataEmailErrorSelector = "[data-error=email]";
  
    constructor(email: HTMLInputElement | null) {
        this.email = email;
        this.element = DOMHelper.querySelector(this.dataEmailErrorSelector) as HTMLElement;
        this.shareArticleErrorMessageElement = this.element && DOMHelper.querySelector(this.errorMessageContainerClass, this.element) as HTMLElement;
  
        if (this.shareArticleErrorMessageElement) {
            this.defaultMessage = this.shareArticleErrorMessageElement.innerHTML;
        }
    }
  
    setMessage(message: string) {
        if (this.shareArticleErrorMessageElement) {
            this.shareArticleErrorMessageElement.innerHTML = (message || this.defaultMessage);
        }
    };
  
    show(message = "") {
        this.setMessage(message);
  
        Utils.showContainer(this.element);
        this.email?.classList.add(MarketingClientConstants.hasErrorClassName);
  
        return false;
    }
  
    hide() {
        Utils.hideContainer(this.element);
        this.email?.classList.remove(MarketingClientConstants.hasErrorClassName);
  
        return true;
    }
  }

  export enum LayerType {
    DEFAULT = "default",
    SUCCESS = "success",
    BLOCKED = "blocked",
    ERROR = "error"
  }

  export const WYBORCZA_PL = window["wyborcza_pl"] || {};